import React from 'react';
import PropTypes from 'prop-types';
import { Box, Typography, useScreenClass } from '@vp/swan';
import get from 'lodash/get';
import { useTranslations } from '@vp/om-translations';
import errorImage from './icons/errorImage.svg';
import ContinueShopping from './ContinueShopping';

// A map of error status to i18n errorMessages Translation Group keys.
const errorMap = {
  401: {
    errorTitleKey: 'unauthorizedToViewOrderErrorTitle',
    errorMessageDetailsKey: 'unauthorizedToViewOrderErrorDetails',
  },
  404: {
    errorTitleKey: 'orderNotFoundErrorTitle',
    errorMessageDetailsKey: 'orderNotFoundErrorDetails',
  },
  default: {
    errorTitleKey: 'defaultErrorTitle',
    errorMessageDetailsKey: 'defaultErrorDetails',
  },
};

// This is a temporary solution for error handling until proper error pages exist
const ErrorHandler = ({ error = {}, pageMessages = {} }) => {
  const screenClass = useScreenClass();
  const status = error?.response?.status;
  const serviceDisruption = get(error.data, 'serviceDisruption');
  const [errorMessages] = useTranslations(['errorMessages']);
  const errorDisplayMessage = serviceDisruption
    ? pageMessages.maintenance
    : errorMessages[
        get(errorMap, status, errorMap.default).errorMessageDetailsKey
      ];
  return (
    <Box mb={7} mt={screenClass === 'xs' ? 7 : 9}>
      <img src={errorImage} alt="" />
      <Typography my={5}>{errorDisplayMessage}</Typography>
      <ContinueShopping />
    </Box>
  );
};

export default ErrorHandler;

ErrorHandler.propTypes = {
  error: PropTypes.object,
  pageMessages: PropTypes.object,
};
